<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      append-to-body
      title="发货通知单选择"
      width="1200px">
    <table-select
        ref="tableSelect"
        url="sd/DeliveryBills"
        module="basic"
        :filter="filter"
        :columns="columns"
        @select="selectDeliveryBill"
        @reset="resetHandle">
      <template slot="adSearch">
        <el-form ref="form" :inline="true" :model="filter" label-width="95px">
          <el-form-item label="订单编号">
            <el-input v-model.trim="filter.billNo" placeholder="请输入订单编号" clearable/>
          </el-form-item>
          <el-form-item label="物料编号">
            <el-input v-model.trim="filter.materialNo" placeholder="请输入物料编号" clearable/>
          </el-form-item>
          <el-form-item label="物料名称">
            <el-input v-model.trim="filter.materialName" placeholder="请输入物料名称" clearable/>
          </el-form-item>
          <el-form-item label="规格型号">
            <el-input v-model.trim="filter.specification" placeholder="请输入规格型号" clearable/>
          </el-form-item>
          <el-form-item label="客户编号">
            <el-input v-model.trim="filter.customerNo" placeholder="请输入客户编号" clearable/>
          </el-form-item>
          <el-form-item label="客户名称">
            <el-input v-model.trim="filter.customerName" placeholder="请输入客户名称" clearable/>
          </el-form-item>
          <el-form-item label="交货日期">
            <el-date-picker
                v-model="filter.deliveryBeginDate"
                type="date"
                style="width:180px"
                value-format="yyyy-MM-dd"
                placeholder="开始日期"/>
          </el-form-item>
          <el-form-item label="至">
            <el-date-picker
                v-model="filter.deliveryEndDate"
                type="date"
                style="width:180px"
                value-format="yyyy-MM-dd"
                placeholder="结束日期"/>
          </el-form-item>
        </el-form>
      </template>
    </table-select>
  </el-dialog>
</template>

<script>
  import TableSelect from "@/components/TableSelect.vue";
  export default {
    components: { TableSelect },
    data() {
      return {
        dialogVisible:false,
        filter:{
          billNo:"",
          materialNo:"",
          materialName:"",
          specification:"",
          customerNo:"",
          customerName:"",
          deliveryBeginDate:"",
          deliveryEndDate:"",
        },
        columns: [
          {
            width: 55,
            align: "center",
            type: "expand",
            render: (h, params) => {
              return h("Table", {
                props: {
                  data: params.row.deliveryBillDetails,
                  columns: [
                    {
                      title: "物料编号",
                      key: "materialNo",
                      width: 160,
                    },
                    {
                      title: "物料名称",
                      key: "materialName",
                      minWidth: 240,
                      tooltip:true,
                    },
                    {
                      title: "规格型号",
                      key: "specification",
                      minWidth: 180,
                    },
                    {
                      title: "数量",
                      key: "quantity",
                      width: 80,
                      align: "center",
                    },
                    {
                      title:"交货日期",
                      key:"deliveryDate",
                      width:120,
                      align:"center",
                    },
                    {
                      title: "单价",
                      key: "price",
                      width: 80,
                      align: "center",
                    },
                    {
                      title: "单位",
                      key: "unit",
                      width: 80,
                      align: "center",
                    },
                    {
                      title: "备注",
                      key: "note",
                      width: 240,
                      tooltip:true,
                    },
                  ],
                  border: true,
                  stripe: true,
                },
              });
            },
          },
          { 
            title:"编号",
            key: "billNo",
            align: "center",
            width: 150,
          },
          {
            title:"客户编号",
            key: "customerNo",
            align: "center",
            width: 120,
          },
          {
            title:"客户名称",
            key: "customerName",
            minWidth: 280,
            tooltip: true,
          },
          {
            title:"金额",
            key: "totalAmount",
            width: 100,
          },
          {
            title:"制单人",
            key: "creatorName",
            width: 80,
            align: "center",
          },
          {
            title:"制单时间",
            key: "createTime",
            width: 160,
            align: "center",
          },
          {
            title: "操作",
            slot: "action",
            width: 80,
            align: "center",
          },
        ],
      };
    },
    methods:{
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.form.resetFields();
          this.$refs.tableSelect.loadData();
        });
      },

      selectDeliveryBill(row) {
        console.log(row);
        this.dialogVisible = false;
        this.$emit("select", row);
      },

      resetHandle(filter) {
        this.filter = filter;
        this.$nextTick(() => {
          this.$refs.tableSelect.loadData();
        });
      },
    },
  };
</script>

<style>

</style>